import { useLayoutEffect, useState } from 'react'

import { useAppDispatch } from 'common/hooks/redux'
import { selectElementAndFetchCampaignData } from 'features/unifiedFlow/store/unifiedFlowSlice'

import { getOptimizedOrPersonalizedElements } from '../../helpers'
import { useContent } from '../../hooks'

const useElementState = () => {
  const [isReady, setIsReady] = useState(false)
  const dispatch = useAppDispatch()
  const { content } = useContent()

  const optimizedOrPersonalizedElements = getOptimizedOrPersonalizedElements(
    content?.elements
  )

  useLayoutEffect(() => {
    const firstEnabledElement = optimizedOrPersonalizedElements.find(
      (element) => element.status !== 'disabled'
    )

    if (firstEnabledElement) {
      const action = dispatch(
        selectElementAndFetchCampaignData(firstEnabledElement)
      )
      setIsReady(true)

      return () => {
        action.abort()
        setIsReady(false)
      }
    }

    // This hook should only run once
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return { isElementReady: isReady }
}

export default useElementState
